import { gql } from '@apollo/client';

export const GET_PAYOUT_LIST = gql`
    query PaypalListPayouts($input: AdminPaypalListPayoutsDTO!) {
        paypalListPayouts(input: $input) {
            message
            data {
                status
                receiver
                payoutId
                createdAt
                id
                payerId
                payerInfo {
                    firstName
                    lastName
                    _id
                    authProvider
                    authProviderId
                }
                updatedAt
                userId
                userInfo {
                    firstName
                    _id
                    lastName
                    authProviderId
                    authProvider
                }
                amount
                currency
                amountInfo {
                    amount
                    applicationFee
                    totalAmount
                    percentage
                }
            }
            pagination {
                total
                hasNextPage
            }
        }
    }
`;
